<script setup lang="ts">
defineProps({
  isSidebarClosed: {
    type: Boolean,
    default: false,
  },
});

type Emits = {
  onClickMenu: [];
  closeMenu: [];
};

const emit = defineEmits<Emits>();
</script>

<template>
  <div :class="[$style.sidebarHeader, { [$style.isClosed]: isSidebarClosed }]">
    <BaseCommonLogo
      allow-redirect
      always-logo
      class="mr-auto max-h-[28px] h-6 md:h-7 !justify-start"
      custom-size
      @click="emit('onClickMenu')"
    />
    <div
      :class="$style.closeMenu"
      @click="emit('closeMenu')"
    >
      <NuxtIcon name="close" />
    </div>
  </div>
</template>

<style module lang="scss">
.sidebarHeader {
  @apply flex justify-between items-center pt-6 px-5 pb-2 lg:hidden;

  .closeMenu {
    @apply w-7 h-7 rounded-full flex items-center justify-center cursor-pointer bg-sidebar-button-bg;

    svg {
      @apply w-4 h-4 text-white;
    }
  }

  &.isClosed {
    @apply pt-6 px-5 pb-2;
  }
}
</style>
